<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard intro_screen' : gameType === 'ODD' ? 'modal modal-game_odd_object intro_screen': 'modal modal-game_spot_difference intro_screen', isIos ? 'ui_desc_ios' : '']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content won_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p v-if="gameType === 'MW'">{{ getTranslations.home_modals_game_intro_mw_description }}</p>
            <p v-if="gameType === 'ODD'">{{ getTranslations.home_modals_game_intro_odd_description }}</p>
            <p v-if="gameType === 'SD'">{{ getTranslations.home_modals_game_intro_sd_description }}</p>
          </div>
        </div>
        <div class="modal__body">
          <h1 v-if="gameType === 'MW'" class="prize_won_headline">{{ getTranslations.games_intro_mw_img_desc }}</h1>
          <h1 v-if="gameType === 'ODD'" class="prize_won_headline">{{ getTranslations.games_intro_oo_img_desc }}</h1>
          <h1 v-if="gameType === 'SD'" class="prize_won_headline">{{ getTranslations.games_intro_std_img_desc }}</h1>
          <div class="prize_won_image prize_won_image_prize">
            <img :src="imageUrlMethod()"/>
            <div class="prize_won_image prize_won_image_conffeti"></div>
          </div>

          <p class="modal_prize_alert" v-if="!isEligibleToPlay(gameType)"> {{
            getTranslations.home_modals_game_intro_no_balance }}</p>

          <p class="cta_support" v-if="gameType === 'MW'">
            <img v-if="gameType === 'MW'" src="static/images/icon-coins-s.png"/>
            {{ mwCoinsCost }} {{ getTranslations.home_modals_game_intro_coins_required}}
          </p>
          <p class="cta_support" v-if="gameType === 'ODD'">
            <img src="static/images/icon-coins-s.png"/>
            {{ oddCoinsCost }} {{ getTranslations.home_modals_game_intro_coins_required}}
          </p>
          <p class="cta_support" v-if="gameType === 'SD'">
            <img src="static/images/icon-coins-s.png"/>
            {{ sdCoinsCost }} {{ getTranslations.home_modals_game_intro_coins_required}}
          </p>

          <a v-if="!isEligibleToPlay(gameType) && !hideStore" class="ti_btn--green modal_cta" style="cursor:pointer"
             @click.prevent="goToStore">{{ getTranslations.home_modals_game_intro_store }}</a>

          <a v-if="isEligibleToPlay(gameType)" class="ti_btn--green modal_cta" style="cursor:pointer"
             @click.prevent="playGame(gameType)">{{ getTranslations.home_modals_game_intro_play }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import NewGameMixin from '@/common/mixins/home';

export default {
  name: 'game-intro',
  mixins: [NewGameMixin],
  data() {
    return {
      isIos: false,
    };
  },
  created() {
    console.log('in GameIntro created hook:');
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
      'isGamePageFlow',
      'updateGameType',
    ]),
    imageUrlMethod() {
      if (this.gameType === 'MW') return this.getTranslations.games_intro_mw_img;
      if (this.gameType === 'ODD') return this.getTranslations.games_intro_oo_img;
      if (this.gameType === 'SD') return this.getTranslations.games_intro_std_img;
      return '';
    },
    goToStore() {
      this.$router.push('/home/store');
      // modals from Game
      this.storeModalForHomePage(null);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'sdCoinsCost',
      'mwCoinsCost',
      'oddCoinsCost',
    ]),
    ...mapState('common', [
      'userDetails',
      'hideStore',
    ]),
    ...mapState('game', [
      'gameType',
      'gameID',
      'playersDetails',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/GameIntro.vue